var exports = {
  "iE": "x4c3adb35--c74f03--wrapper",
  "Hw": "x4c3adb35--c74f03--mobile",
  "_8": "x4c3adb35--c74f03--img",
  "Qs": "x4c3adb35--c74f03--content",
  "DD": "x4c3adb35--c74f03--title",
  "p_": "x4c3adb35--c74f03--list",
  "nM": "x4c3adb35--c74f03--row",
  "Kk": "x4c3adb35--c74f03--icon",
  "Rm": "x4c3adb35--c74f03--secondary",
  "ne": "x4c3adb35--c74f03--controls",
  "lZ": "x4c3adb35--c74f03--phone",
  "nf": "x4c3adb35--c74f03--link",
  "aL": "x4c3adb35--c74f03--legal",
  "Hc": "x4c3adb35--c74f03--marketing",
};

module.exports = exports;
